import React from 'react';
import { Grid } from '@mui/material';
import { Body1, H1, Subtitle1 } from '../../../components/typography';
import { PrimaryButton } from '../../../components/buttons';
import { SearchInput, SelectInput } from '../../../components/inputs';
import { MailReminderActive, MailReminderStrategy } from '../../../models/mailReminder';
import { useTranslation } from 'react-i18next';
import { CustomCard } from '../../../components/card';
import { enumToOptions } from '../../../utils/misc';

interface Props {
  setIsOpen: (value: boolean) => void,
  handleQuery: (query: {
    search?: string;
    active?: string;
    strategy?: string;
  }) => void
}

const Header: React.FC<Props> = ({
  setIsOpen,
  handleQuery
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={8}>
          <H1>{t('Mail Reminders')}</H1>
          <Subtitle1>{t('List of mail reminders:')}</Subtitle1>
        </Grid>
        <Grid size={4}>
          <Body1 align='right'>
            <PrimaryButton onClick={() => setIsOpen(true)}>{t('Add Reminder')}</PrimaryButton>
          </Body1>
        </Grid>
      </Grid>
      <CustomCard>
        <Grid container spacing={2} marginY={1}>
          <Grid size={4}>
            <SearchInput onChange={search => handleQuery({ search })} />
          </Grid>
          <Grid size={4}>
            <SelectInput
              label={t('Status')}
              onChange={(e) => { handleQuery({ active: e.target.value }); }}
              options={enumToOptions(MailReminderActive)}
            />
          </Grid>
          <Grid size={4}>
            <SelectInput
              label={t('Strategy')}
              onChange={(e) => { handleQuery({ strategy: e.target.value }); }}
              options={enumToOptions(MailReminderStrategy)}
            />
          </Grid>
        </Grid>
      </CustomCard>
    </>
  );
};

export default Header;
